
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bootcamp/select-grade/[countryCode]",
      function () {
        return require("private-next-pages/bootcamp/select-grade/[countryCode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bootcamp/select-grade/[countryCode]"])
      });
    }
  